export default {"src":"/_next/static/media/enerflo-platform-icon-open-platform.70f69b5b.svg","height":160,"width":160};